<hr
  class="line-{{ initOptions.borderStyle }} {{ initOptions.style }}"
  [ngStyle]="{ 'border-top-width': initOptions.size + 'px', 'width': initOptions.width + 'px' }"
  id="line_mc{{ initOptions.id }}" />
<!-- original id was: id="line_mc" what is not unique, so changing it to combine with id -->
